import { Component, inject, Input } from '@angular/core';
import { ProviderSearchDetailsLocationCardComponent } from '../provider-search-details-location-card/provider-search-details-location-card.component';
import { CommonModule } from '@angular/common';
import { SearchStateService } from '../../shared/services/search-state.service';
import { MCAppGatewayService } from '../../../shared/services/mcappgateway/mcappgateway.service';
import { GetCareNowFormatService } from '../../../get-care-now-feature/utilities/getcarenow-format.service';
import { TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { environment } from '../../../../environments/environment';
import { MonitoringService } from '../../../shared/services/monitoring/monitoring-service';

@Component({
  selector: 'app-provider-search-details',
  imports: [CommonModule, MatProgressSpinnerModule, ProviderSearchDetailsLocationCardComponent],
  templateUrl: './provider-search-details.component.html',
  styleUrl: './provider-search-details.component.css'
})
export class ProviderSearchDetailsComponent {

  mcAppGateway = inject(MCAppGatewayService);
  searchState = inject(SearchStateService);
  private getCareNowFormatService: GetCareNowFormatService;

  @Input() locale: string = '';
  @Input() currentLocation: any = null;
  @Input() currentCityOrZip: string = "";
  @Input() fromLocationSearch: boolean = false;
  @Input() locationDetails: any = null;

  providerDetails$ = this.searchState.providerDetails$;
  locationDetailsProvider$ = this.searchState.locationDetailsProvider$;
  showSpinner$ = this.searchState.showSpinner$;
  providerSearchFilter$ = this.searchState.providerSearchFilters$;

  showSpinner: boolean = false;
  details: any = null;
  waitTime: string = '';
  locationList: any[] = [];
  
  breadcrumbText = "Provider Search";
  breadcrumbText2 = "Search Results";
  aboutLabel = "";
  affiliationsLabel = "";
  educationLabel = "";
  langLabel = "";
  locationsLabel = "";

  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(sessionStorage.getItem('locale') || 'en-US'); // Default to 'en-US' if no locale is provided
    this.getCareNowFormatService = new GetCareNowFormatService(this.translate);
  }

  ngOnInit(): void {
    this.showSpinner = true;

    // Additional initialization logic can go here
    this.showSpinner$.subscribe(show => {
      this.showSpinner = show;
    });

    if (this.fromLocationSearch === true)  {
      this.translate.get('LOCATION_SEARCH').subscribe((translated: string) => {
        this.breadcrumbText = translated;
      });
    } 
    else {
      this.translate.get('PROVIDER_SEARCH').subscribe((translated: string) => {
      this.breadcrumbText = translated;
    });
    }
  
    this.translate.get('RESULTS').subscribe((translated: string) => {
      this.breadcrumbText2 = translated;
    });

    this.translate.get('PROVIDER_PROFILE.ABOUT').subscribe(translated => {
      this.aboutLabel = translated;
    });

    this.translate.get('PROVIDER_PROFILE.EDUCATION').subscribe(translated => {
      this.educationLabel = translated;
    });

    this.translate.get('PROVIDER_PROFILE.LOCATIONS').subscribe(translated => {
      this.locationsLabel = translated;
    });

    this.translate.get('FILTERS.LANGUAGES').subscribe(translated => {
      this.langLabel = translated;
    });

    this.translate.get('LOCATION_PROFILE.AFFILIATIONS').subscribe(translated => {
      this.affiliationsLabel = translated;
    });

    this.translate.get('PROVIDER_PROFILE.LOCATIONS').subscribe(translated => {
      this.locationsLabel = translated;
    });

    this.searchState.providerSearchQuery$.subscribe(query => {
      if (query) {
        this.currentCityOrZip = query.cityOrZip;
      }
    });

    this.searchState.providerDetails$.subscribe(details => {
      if (details) {
        // You can perform actions based on the provider details here
        console.log('Provider Details:', details);
        this.details = details;
        this.locationList = details.locations || [];

        this.waitTime = this.getCareNowFormatService.formatNextAvailability(this.details.nextAvailability); // update the next availability to display
      }
    });
  }

  scheduleAuth() {
    var deepLink = environment.web_scheduling_deep_link_base_url;
    deepLink += "?workflow=NewProvider"
 
    deepLink += "&selProvId=" + this.details.providerEmrId;
    // deepLink += "&selRfvId=" + environment.office_visit_prc_id;
     
    if (this.details.departmentId != null && this.details.departmentId != '') {
      deepLink += "&selDepId=" + this.details.departmentId;
    }
 
    if (this.details.specialtyId != null && this.details.specialtyId != '') {
      deepLink += "&selSpecialtyId=" + this.details.specialtyId;
    }

    var searchMethod = sessionStorage.getItem('providerSearchMethod') ?? '';

    if (searchMethod.length > 0) {
      if (searchMethod === 'freeText') {
        deepLink += "&linksource=AUTHHMPLFRSPC";
      }
      else if (searchMethod === 'quickSearch') {
        deepLink += "&linksource=AUTHHMPLQSPC";
      }
    }

    console.log('Deep Link URL:', deepLink);

    this.monitoringService.logEvent('Schedule', { feature: 'search', subfeature: 'provider-search', platform: 'web'}); // log as mobile or web event

    window.location.href = deepLink;
  }

  scheduleUnauth() {
    var deepLink = environment.web_open_scheduling_deep_link_base_url;

    deepLink += "/standalone"; // Use standalone workflow for unauthenticated users)

    deepLink += "?id=" + this.details.providerEmrId;
    // deepLink += "&vt=" + environment.office_visit_prc_id;

    if (this.details.departmentId != null && this.details.departmentId != '') {
      deepLink += "&dept=" + this.details.departmentId;
    }
 
    if (this.details.specialtyId != null && this.details.specialtyId != '') {
      deepLink += "&specialty=" + this.details.specialtyId;
    }

    deepLink += "&linksource=PLUAFPPROFSCHED";

    console.log('Deep Link URL:', deepLink);

    this.monitoringService.logEvent('Schedule/NoAuth', { feature: 'search-care-now', subfeature: 'provider', platform: 'web'}); // log as mobile or web event
      
    window.location.href = deepLink;
  }
  
  onScheduleButtonClicked() {
    console.log('Scheduling button clicked for provider:', this.details);
    if (this.details && this.details.providerEmrId && this.details.providerEmrId.length > 0) {
      const eptID = sessionStorage.getItem("eptID");
      if (eptID != null && eptID != '') {
        this.scheduleAuth();
      }
      else {
        this.scheduleUnauth();
      }
    }
  }

  returnToSearchResults() {
    if (this.fromLocationSearch === true) { // Location Detail view from Location Search
      this.searchState.clearCurrentLocationDetailsProvider();
      this.searchState.clearCurrentLocationDetails();
    }
    else {
      // Logic to return to search results view
     this.searchState.clearCurrentProviderDetails();
    }
  }

  clearSearch(): void {
    if (this.fromLocationSearch === true) { // Location Detail view from Location Search
      this.searchState.setLocationSearchFilterToggle(false);
      this.searchState.setLocationSearchQuery({ facilityOrLocationName: "", cityOrZip: this.currentCityOrZip })
      this.searchState.clearLocationSearchFilters();
      this.searchState.clearLocationSearchResults();   
      this.searchState.clearCurrentLocationDetails();
      this.searchState.clearCurrentProviderDetails();
      this.searchState.clearCurrentLocationDetailsProvider();
    }
    else {  
      this.searchState.setProviderSearchFilterToggle(false);
      this.searchState.setProviderSearchQuery({ nameOrSpecialty: "", cityOrZip: this.currentCityOrZip })
      this.searchState.clearProviderSearchFilters();
      this.searchState.clearProviderSearchResults();
      this.searchState.clearCurrentProviderDetails()
    }
  }

  returnToLocationDetails() {
    // Logic to return to locagion details view
    this.searchState.clearCurrentLocationDetailsProvider();
  }
}